// Module
var code = `<a class="panel_button" onclick="event.preventDefault(),navigateLink(this)">#LABEL</a>`;
// Exports
export default code;